// wrapping SVG in a ReactComponent because symlinking SVGs gets complicated in terms of webpack etc
export default function WaeGenIcon() {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.646 18.0116C16.5163 17.7554 19.5984 14.6288 19.8519 10.7039C19.9009 9.93612 19.9009 9.1406 19.8519 8.37283C19.5984 4.44888 16.5163 1.32415 12.646 1.06607C11.3092 0.977977 9.96811 0.977977 8.63136 1.06607C4.76106 1.32323 1.67888 4.44888 1.42542 8.37376C1.37642 9.15001 1.37642 9.92857 1.42542 10.7048C1.51792 12.134 2.14972 13.4577 2.89436 14.5751C3.32635 15.3568 3.04144 16.3327 2.59095 17.1865C2.26719 17.8016 2.10439 18.1087 2.23482 18.3307C2.36432 18.5527 2.6557 18.5601 3.23754 18.574C4.3892 18.6017 5.1653 18.2761 5.78136 17.822C6.1301 17.5639 6.30492 17.4353 6.42518 17.4205C6.54543 17.4057 6.78316 17.5037 7.25677 17.698C7.68229 17.8738 8.17717 17.982 8.63044 18.0125C9.9486 18.0995 11.326 18.0995 12.6469 18.0125"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.47656 12.5633L8.18046 7.45164C8.22323 7.32408 8.305 7.21318 8.41422 7.1346C8.52343 7.05603 8.65458 7.01375 8.78912 7.01375C8.92367 7.01375 9.05481 7.05603 9.16403 7.1346C9.27325 7.21318 9.35502 7.32408 9.39779 7.45164L11.1017 12.5633M13.8768 7.01318V12.5633M7.40159 10.7133H10.1767"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
